import axios, { CancelToken } from 'axios';

import { IInvestimentoACadastrar, IFonteInvestimento, ICreateInvestimentoParams, IAlterarContaInvestimentoParams } from '../../../../pages/SaldoDeContas/InvestimentosACadastrar/interfaces';

import { GATEWAY_API_URL } from "../../../request/urls";
import { getToken } from "../../../token";

class InvestimentosACadastrarService {
    private readonly baseURL = `${GATEWAY_API_URL}/saldo-empenhos/conta/investimento`;

    async getQuantidadeInvestimentosACadastrar(): Promise<number> {
        const { data } = await axios.get(`${this.baseURL}/qtde-a-cadastrar`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
        });

        return data.quantidade_a_cadastrar;
    }

    async getInvestimentosACadastrar(signal?: CancelToken): Promise<IInvestimentoACadastrar[]> {
        const { data } = await axios.get(`${this.baseURL}/a-cadastrar`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            cancelToken: signal
        });

        return data.investimentosACadastrar.map((investimento: IInvestimentoACadastrar) => {
            return {
                ...investimento,
                orgaoVinculado: {
                    ...investimento.orgaoVinculado,
                    orgaoNome: investimento.orgaoVinculado?.orgao?.nome,
                }
            };
        });
    }

    async getFontesInvestimento(id: number, signal?: CancelToken): Promise<IFonteInvestimento[]> {
        const { data } = await axios.get(`${this.baseURL}/a-cadastrar/${id}/fontes`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            cancelToken: signal
        });

        return data.fontes;
    }

    async createInvestimento({
        investimentoACadastrarId,
        contaId,
    }: ICreateInvestimentoParams): Promise<any> {
        const { data } = await axios.post(
            `${this.baseURL}`,
            {
                investimentoACadastrarId,
                contaId,
            },
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
            }
        );

        return data;
    }

    async getFontesParaMoverInvestimento(
        investimentoId: number,
        signal?: CancelToken
    ): Promise<IFonteInvestimento[]> {
        const { data } = await axios.get(
            `${this.baseURL}/${investimentoId}/fontes`,
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                cancelToken: signal
            }
        );

        return data.fontes;
    }

    async alterarContaInvestimento({
        investimentoId,
        contaId,
    }: IAlterarContaInvestimentoParams): Promise<any> {
        const { data } = await axios.patch(
            `${this.baseURL}/${investimentoId}/conta`,
            {
                contaId,
            },
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
            }
        );

        return data;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new InvestimentosACadastrarService();
